<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="470px"
    :before-close="handleClose"
    :close-on-click-modal="false"
    custom-class="detail-modal"
  >
    是否删除 {{ name }}？
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleOk" v-loading="loading"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { delFilesFetch } from "../../api/material";
export default {
  data() {
    return {
      visible: false,
      name: "",
      folderId: null,
      fileName: null,
      loading: false,
      title: null,
    };
  },
  methods: {
    handleClose() {
      this.visible = false;
      this.$emit("clearOptionValue");
    },
    showModal(names, folderId, uuids) {
      this.visible = true;
      this.title = names.length > 1 ? "删除素材" : names.join(",");
      this.name = names.join(" ");
      this.folderId = folderId;
      this.fileName = uuids.join(",");
    },
    handleOk() {
      this.loading = true;
      delFilesFetch({ folderId: this.folderId, fileNames: this.fileName })
        .then((res) => {
          if (res.code == "0000") {
            this.$message.success("删除成功");
            this.$emit("updateTags", this.folderId);
            this.visible = false;
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>